import * as Joi from "joi";
import { Moment } from 'moment';
import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { booleanTransformer, GenPartial, momentTransformer } from 'typeormgen';
import Base from '../base.entity';

@Entity('cm_item_pictures')
export default class CmItemPicture extends Base {
	static tableName = 'cm_item_pictures';

	@PrimaryGeneratedColumn()
	id: number;

	@Column('varchar')
	mobile_id: string;

	@Column('int')
	prod_id: number;

	@Column('int')
	picture_id: number;

	@Column('int')
	item_id: number;

	@Column('int')
	cm_episodic_item_picture_id: number;

	@Column({ type: 'tinyint', transformer: booleanTransformer })
	main_photo: boolean;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	last_updated_time: Moment;

	@Column('int')
	last_updated_user: number;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	date_created: Moment;

	@Column('int')
	created_by: number;

	static rules() {
		return {
			id: Joi.number().integer(),
			mobile_id: Joi.string().max(36).allow(null, ''),
			prod_id: Joi.number().integer(),
			picture_id: Joi.number().integer(),
			item_id: Joi.number().integer(),
			cm_episodic_item_picture_id: Joi.number().integer().allow(null),
			main_photo: Joi.boolean(),
			last_updated_time: Joi.date().allow(null),
			last_updated_user: Joi.number().integer(),
			date_created: Joi.date().allow(null),
			created_by: Joi.number().integer(),
		};
	}

	toJSON() {
		return {
			id: this.id,
			mobile_id: this.mobile_id,
			prod_id: this.prod_id,
			picture_id: this.picture_id,
			item_id: this.item_id,
			cm_episodic_item_picture_id: this.cm_episodic_item_picture_id,
			main_photo: this.main_photo,
			last_updated_time: this.last_updated_time,
			last_updated_user: this.last_updated_user,
			date_created: this.date_created,
			created_by: this.created_by,
		};
	}

	assign(props?: GenPartial<CmItemPicture>) {
		super.assign(props);

		if (props) {
			if (typeof props.main_photo !== 'undefined') {
				this.main_photo = booleanTransformer.from(props.main_photo);
			}
			if (typeof props.last_updated_time !== 'undefined') {
				this.last_updated_time = momentTransformer.from(
					props.last_updated_time
				);
			}
			if (typeof props.date_created !== 'undefined') {
				this.date_created = momentTransformer.from(props.date_created);
			}
		}
	}

	constructor(props?: GenPartial<CmItemPicture>) {
		super(props);
	}
}
